module.exports = __webpack_public_path__ + "img/vip-s@3x.bf61461.png";